var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.833 34.292 22.125 23.583q-1.25 1.084-2.896 1.667t-3.396.583q-4.25 0-7.208-2.937-2.958-2.938-2.958-7.146 0-4.25 2.958-7.188 2.958-2.937 7.167-2.937 4.208 0 7.166 2.937 2.959 2.938 2.959 7.188 0 1.75-.605 3.396-.604 1.646-1.687 2.937L34.333 32.75ZM15.792 23.75q3.375 0 5.687-2.333 2.313-2.334 2.313-5.667 0-3.375-2.313-5.708-2.312-2.334-5.687-2.334-3.334 0-5.688 2.334Q7.75 12.375 7.75 15.75q0 3.333 2.354 5.667 2.354 2.333 5.688 2.333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchButton);
export default __webpack_public_path__ + "static/media/search-button.4a269077d7c9175891e834399e460e90.svg";
export { ForwardRef as ReactComponent };